/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface LegalResponse
 */
export interface LegalResponse {
    /**
     * 
     * @type {string}
     * @memberof LegalResponse
     */
    terms: string;
    /**
     * 
     * @type {string}
     * @memberof LegalResponse
     */
    privacy: string;
}

export function LegalResponseFromJSON(json: any): LegalResponse {
    return {
        'terms': json['terms'],
        'privacy': json['privacy'],
    };
}

export function LegalResponseToJSON(value?: LegalResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'terms': value.terms,
        'privacy': value.privacy,
    };
}


